import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DashboardMetricListPage from '../components/dashboard/DashboardMetricListPage';

function useMetricPeriodParams() {
  const [searchParams] = useSearchParams();
  const year = searchParams.get('year');
  const month = searchParams.get('month');
  const hasYearMonth = year && month;
  const period = hasYearMonth || searchParams.get('period') === 'month' ? 'month' : 'today';
  return { year, month, hasYearMonth, period };
}

const DashboardMetricPayments = () => {
  const { t } = useTranslation();
  const { year, month, hasYearMonth, period } = useMetricPeriodParams();

  const apiPath = useMemo(() => {
    if (hasYearMonth) {
      return `/api/dashboard/metrics/payments?year=${year}&month=${month}`;
    }
    return `/api/dashboard/metrics/payments?period=${period}`;
  }, [hasYearMonth, year, month, period]);

  const title = period === 'month'
    ? t('dashboard.activity.paymentsMonthTitle')
    : t('dashboard.activity.paymentsTodayTitle');

  const subtitle = period === 'month'
    ? (hasYearMonth
      ? t('dashboard.activity.paymentsMonthSelectedSubtitle', { year, month })
      : t('dashboard.activity.paymentsMonthSubtitle'))
    : t('dashboard.activity.paymentsTodaySubtitle');

  return (
    <DashboardMetricListPage
      apiPath={apiPath}
      title={title}
      subtitle={subtitle}
      countLabel={t('dashboard.activity.totalPayments')}
      emptyMessage={t('dashboard.activity.noPayments')}
      loadFailedMessage={t('dashboard.activity.loadPaymentsFailed')}
      requiredPermissions={['view_dashboard_today', 'view_dashboard_monthly_payments']}
    />
  );
};

export default DashboardMetricPayments;
